// 2025 Topps Star Wars Masterwork — GENERATED by pipeline-publish (2026-06-04)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2025-masterwork.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2025-masterwork",
//     name: "2025 Topps Star Wars Masterwork",
//     shortName: "2025 Masterwork",
//     year: 2025,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2025",
//     totalCards: 868,
//     description: "Topps' premium Star Wars release: a 100-card base of refractor-style parallels, on-card autographs from a 96-signer roster, Skeleton Crew and ROTJ Film Cel relics, Ultimate Book Card and Pen Autograph relics, and 1/1 hand-drawn sketch cards from 200+ artists.",
//     color: "#c9a227",
//     accentColor: "#f0c040",
//     dataFile: "2025-masterwork",
//   },
// =============================================================================

export const SETS = [
  {
    id: "characters",
    type: "base",
    title: "CHARACTERS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "1", name: "Luke Skywalker" },
        { n: "2", name: "R2-D2" },
        { n: "3", name: "Han Solo" },
        { n: "4", name: "Jedi Master Sol" },
        { n: "5", name: "Jedi Master Indara" },
        { n: "6", name: "Jod Na Nawood" },
        { n: "7", name: "Yoda" },
        { n: "8", name: "Grogu" },
        { n: "9", name: "Neel" },
        { n: "10", name: "Captain Brutus" },
        { n: "11", name: "Jedi Master Vernestra Rwoh" },
        { n: "12", name: "The Stranger" },
        { n: "13", name: "Boba Fett" },
        { n: "14", name: "The Mandalorian" },
        { n: "15", name: "Captain Phasma" },
        { n: "16", name: "Padmé Amidala" },
        { n: "17", name: "Anakin Skywalker" },
        { n: "18", name: "Obi-Wan Kenobi" },
        { n: "19", name: "Shin Hati" },
        { n: "20", name: "Baylan Skoll" },
        { n: "21", name: "Grand Admiral Thrawn" },
        { n: "22", name: "Ahsoka Tano" },
        { n: "23", name: "Sabine Wren" },
        { n: "24", name: "Ezra Bridger" },
        { n: "25", name: "Hera Syndulla" },
        { n: "26", name: "Chopper" },
        { n: "27", name: "Imperial Snowtrooper" },
        { n: "28", name: "Mace Windu" },
        { n: "29", name: "Darth Vader" },
        { n: "30", name: "Jyn Erso" },
        { n: "31", name: "Cassian Andor" },
        { n: "32", name: "Mon Mothma" },
        { n: "33", name: "Luthen Rael" },
        { n: "34", name: "Maul" },
        { n: "35", name: "Cobb Vanth" },
        { n: "36", name: "Dedra Meero" },
        { n: "37", name: "Rebel Trooper" },
        { n: "38", name: "Chewbacca" },
        { n: "39", name: "Qui-Gon Jinn" },
        { n: "40", name: "Rey" },
        { n: "41", name: "Kylo Ren" },
        { n: "42", name: "Kleya Marki" },
        { n: "43", name: "Ryder Azadi" },
        { n: "44", name: "C-3PO" },
        { n: "45", name: "Jedi Master Kelnacca" },
        { n: "46", name: "Bo-Katan Kryze" },
        { n: "47", name: "Greef Karga" },
        { n: "48", name: "Vel Sartha" },
        { n: "49", name: "Cinta Kaz" },
        { n: "50", name: "Arvel Skeen" },
        { n: "51", name: "Lando Calrissian" },
        { n: "52", name: "Syril Karn" },
        { n: "53", name: "Morgan Elsbeth" },
        { n: "54", name: "Supervisor Lonni Jung" },
        { n: "55", name: "Director Orson Krennic" },
        { n: "56", name: "BB-8" },
        { n: "57", name: "Saw Gerrera" },
        { n: "58", name: "Jedi Master Dooku" },
        { n: "59", name: "Major Partagaz" },
        { n: "60", name: "Tredgar Volk" },
        { n: "61", name: "Vane" },
        { n: "62", name: "Migs Mayfeld" },
        { n: "63", name: "Grand Moff Tarkin" },
        { n: "64", name: "General Hux" },
        { n: "65", name: "Wilmon Paak" },
        { n: "66", name: "Darth Sidious" },
        { n: "67", name: "Snap Wexley" },
        { n: "68", name: "Maz Kanata" },
        { n: "69", name: "Bix Caleen" },
        { n: "70", name: "Kaydel Connix" },
        { n: "71", name: "Qi'ra" },
        { n: "72", name: "Jedi Padawan Jecki Lon" },
        { n: "73", name: "Boolio" },
        { n: "74", name: "Chirrut Îmwe" },
        { n: "75", name: "SM-33" },
        { n: "76", name: "K-2SO" },
        { n: "77", name: "Poe Dameron" },
        { n: "78", name: "Moff Gideon" },
        { n: "79", name: "Asajj Ventress" },
        { n: "80", name: "Admiral Ackbar" },
        { n: "81", name: "Kh'ymm" },
        { n: "82", name: "Cad Bane" },
        { n: "83", name: "Haja Estree" },
        { n: "84", name: "Jar Jar Binks" },
        { n: "85", name: "Jawa" },
        { n: "86", name: "Bail Organa" },
        { n: "87", name: "Moroff" },
        { n: "88", name: "The Fourth Sister" },
        { n: "89", name: "The Fifth Brother" },
        { n: "90", name: "The Seventh Sister" },
        { n: "91", name: "IG-12" },
        { n: "92", name: "Vulptex" },
        { n: "93", name: "Fennec Shand" },
        { n: "94", name: "Vect Nokru" },
        { n: "95", name: "Gunter" },
        { n: "96", name: "Zett Jukassa" },
        { n: "97", name: "Babu Frik" },
        { n: "98", name: "General Grievous" },
        { n: "99", name: "Lobot" },
        { n: "100", name: "Leia Organa" },
    ],
  },
  {
    id: "bb-8",
    type: "insert",
    title: "BB-8",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "colored-metal", name: "Colored Metal", print_run: 25, color: "#7fcdd0" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "BB8-1", name: "An Initial Threat" },
        { n: "BB8-2", name: "Freed By Rey" },
        { n: "BB8-3", name: "Shocking Finn" },
        { n: "BB8-4", name: "Rolling In The Millennium Falcon" },
        { n: "BB8-5", name: "Thumbs Up" },
        { n: "BB8-6", name: "Reunited With Poe Dameron" },
        { n: "BB8-7", name: "Waking Up R2-D2" },
        { n: "BB8-8", name: "Rolling Slot Machine" },
        { n: "BB8-9", name: "Carried by Chewbacca" },
        { n: "BB8-10", name: "Fixing D-O" },
    ],
  },
  {
    id: "fall-of-the-chosen-one",
    type: "insert",
    title: "FALL OF THE CHOSEN ONE",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "FALL-1", name: "\"I Sense Great Fear In You\"" },
        { n: "FALL-2", name: "\"Do It\"" },
        { n: "FALL-3", name: "Padmé Amidala's Confession" },
        { n: "FALL-4", name: "Blinded by Love" },
        { n: "FALL-5", name: "Anakin Skywalker's Troubling Vision" },
        { n: "FALL-6", name: "Yoda's Counsel" },
        { n: "FALL-7", name: "The Eyes, Ears, And Voice Of The Republic" },
        { n: "FALL-8", name: "An Outburst At The Council" },
        { n: "FALL-9", name: "An Unofficial Assignment" },
        { n: "FALL-10", name: "A Request From Padmé Amidala" },
        { n: "FALL-11", name: "\"Not From A Jedi\"" },
        { n: "FALL-12", name: "Obi-Wan Kenobi Chosen Over Anakin Skywalker" },
        { n: "FALL-13", name: "A Brother's Final Goodbye" },
        { n: "FALL-14", name: "A Sith Lord, Revealed" },
        { n: "FALL-15", name: "Conflicted" },
        { n: "FALL-16", name: "\"I Am The Senate\"" },
        { n: "FALL-17", name: "A Fatal Choice" },
        { n: "FALL-18", name: "Anakin Skywalker Becomes Darth Vader" },
        { n: "FALL-19", name: "Knightfall" },
        { n: "FALL-20", name: "Finishing Off The Separatists" },
        { n: "FALL-21", name: "The First Galactic Empire" },
        { n: "FALL-22", name: "The End Of Brotherhood" },
        { n: "FALL-23", name: "More Machine Than Man" },
        { n: "FALL-24", name: "The Sith Lords" },
    ],
  },
  {
    id: "galactic-die-cut-pods",
    type: "insert",
    title: "GALACTIC DIE CUT PODS",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "GPOD-1", name: "Padmé Amidala" },
        { n: "GPOD-2", name: "Bail Organa" },
        { n: "GPOD-3", name: "Mon Mothma" },
        { n: "GPOD-4", name: "Mas Amedda" },
        { n: "GPOD-5", name: "Nute Gunray" },
        { n: "GPOD-6", name: "Riyo Chuchi" },
        { n: "GPOD-7", name: "Mee Deechi" },
        { n: "GPOD-8", name: "Rush Clovis" },
        { n: "GPOD-9", name: "Onaconda Farr" },
        { n: "GPOD-10", name: "Halle Burtoni" },
        { n: "GPOD-11", name: "Orn Free Taa" },
        { n: "GPOD-12", name: "Hamato Xiono" },
        { n: "GPOD-13", name: "Aks Moe" },
        { n: "GPOD-14", name: "Mina Bonteri" },
        { n: "GPOD-15", name: "Sheev Palpatine" },
        { n: "GPOD-16", name: "Sly Moore" },
        { n: "GPOD-17", name: "Gall Trayvis" },
        { n: "GPOD-18", name: "Nix Card" },
        { n: "GPOD-19", name: "Kharrus" },
        { n: "GPOD-20", name: "Lott Dod" },
        { n: "GPOD-21", name: "Ask Aak" },
        { n: "GPOD-22", name: "Finis Valorum" },
        { n: "GPOD-23", name: "Jar Jar Binks" },
        { n: "GPOD-24", name: "Darth Sidious" },
    ],
  },
  {
    id: "lothal-jedi-temple-mortis-gods-painting-puzzle",
    type: "insert",
    title: "LOTHAL JEDI TEMPLE MORTIS GODS PAINTING PUZZLE",
    parallels: [],
    cards: [
        { n: "MORTIS-1", name: "Piece 1" },
        { n: "MORTIS-2", name: "Piece 2" },
        { n: "MORTIS-3", name: "Piece 3" },
        { n: "MORTIS-4", name: "Piece 4" },
        { n: "MORTIS-5", name: "Piece 5" },
        { n: "MORTIS-6", name: "Piece 6" },
        { n: "MORTIS-7", name: "Piece 7" },
        { n: "MORTIS-8", name: "Piece 8" },
        { n: "MORTIS-9", name: "Piece 9" },
    ],
  },
  {
    id: "relic-cards",
    type: "insert",
    title: "RELIC CARDS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "REL-1", name: "The Mandalorian Outland TIE Fighter: The Mandalorian" },
        { n: "REL-2", name: "Ezra Bridger TIE Fighter: Ahsoka" },
        { n: "REL-3", name: "Death Trooper Outland TIE Fighter: The Mandalorian" },
        { n: "REL-4", name: "Captain Enoch TIE Fighter: Ahsoka" },
        { n: "REL-5", name: "Huyang TIE Fighter: Ahsoka" },
        { n: "REL-6", name: "Morgan Elsbeth TIE Fighter: Ahsoka" },
        { n: "REL-7", name: "Ahsoka Tano TIE Fighter: Ahsoka" },
        { n: "REL-8", name: "Sabine Wren TIE Fighter: Ahsoka" },
        { n: "REL-9", name: "Jawa Outland TIE Fighter: The Mandalorian" },
        { n: "REL-10", name: "Moff Gideon Outland TIE Fighter: The Mandalorian" },
        { n: "REL-11", name: "Cassian Andor Missle: Andor" },
        { n: "REL-12", name: "Dedra Meero Vaporator: Andor" },
    ],
  },
  {
    id: "rotj-film-cel",
    type: "insert",
    title: "ROTJ FILM CEL",
    parallels: [],
    cards: [
        { n: "ROC-1", name: "Moff Jerjerrod" },
        { n: "ROC-2", name: "Darth Vader" },
        { n: "ROC-3", name: "R2-D2" },
        { n: "ROC-4", name: "C-3PO" },
        { n: "ROC-5", name: "Bib Fortuna" },
        { n: "ROC-6", name: "Jabba the Hutt" },
        { n: "ROC-7", name: "R2-D2" },
        { n: "ROC-8", name: "Salacious B. Crumb" },
        { n: "ROC-9", name: "Bib Fortuna" },
        { n: "ROC-10", name: "Han Solo" },
        { n: "ROC-11", name: "EV-9D9" },
        { n: "ROC-12", name: "Sy Snootles" },
        { n: "ROC-13", name: "Max Rebo" },
        { n: "ROC-14", name: "C-3PO" },
        { n: "ROC-15", name: "Chewbacca" },
        { n: "ROC-16", name: "Boba Fett" },
        { n: "ROC-17", name: "Lando Calrissian" },
        { n: "ROC-18", name: "Leia Organa" },
        { n: "ROC-19", name: "Leia Organa" },
        { n: "ROC-20", name: "Han Solo" },
        { n: "ROC-21", name: "Luke Skywalker" },
        { n: "ROC-22", name: "Gamorrean Guard" },
        { n: "ROC-23", name: "Malakili" },
        { n: "ROC-24", name: "R2-D2" },
        { n: "ROC-25", name: "Luke Skywalker" },
        { n: "ROC-26", name: "Boba Fett" },
        { n: "ROC-27", name: "Luke Skywalker" },
        { n: "ROC-28", name: "Imperial Royal Guard" },
        { n: "ROC-29", name: "Yoda" },
        { n: "ROC-30", name: "Luke Skywalker" },
        { n: "ROC-31", name: "Lando Calrissian" },
        { n: "ROC-32", name: "Mon Mothma" },
        { n: "ROC-33", name: "Admiral Ackbar" },
        { n: "ROC-34", name: "Han Solo" },
        { n: "ROC-35", name: "The Emperor" },
        { n: "ROC-36", name: "Chewbacca" },
        { n: "ROC-37", name: "Leia Organa" },
        { n: "ROC-38", name: "Luke Skywalker" },
        { n: "ROC-39", name: "Wicket W. Warrick" },
        { n: "ROC-40", name: "The Emperor" },
        { n: "ROC-41", name: "Logray" },
        { n: "ROC-42", name: "C-3PO" },
        { n: "ROC-43", name: "Leia Organa" },
        { n: "ROC-44", name: "C-3PO" },
        { n: "ROC-45", name: "C-3PO" },
        { n: "ROC-46", name: "Leia Organa" },
        { n: "ROC-47", name: "Luke Skywalker" },
        { n: "ROC-48", name: "Han Solo" },
        { n: "ROC-49", name: "Sy Snootles" },
        { n: "ROC-50", name: "Darth Vader" },
        { n: "ROC-51", name: "Luke Skywalker" },
        { n: "ROC-52", name: "Wicket W. Warrick" },
        { n: "ROC-53", name: "Admiral Ackbar" },
        { n: "ROC-54", name: "Nien Nunb" },
        { n: "ROC-55", name: "Wicket W. Warrick" },
        { n: "ROC-56", name: "R2-D2" },
        { n: "ROC-57", name: "Han Solo" },
        { n: "ROC-58", name: "Imperial Royal Guard" },
        { n: "ROC-59", name: "The Emperor" },
        { n: "ROC-60", name: "Wicket W. Warrick" },
        { n: "ROC-61", name: "Wedge Antilles" },
        { n: "ROC-62", name: "Admiral Ackbar" },
        { n: "ROC-63", name: "The Emperor" },
        { n: "ROC-64", name: "Logray" },
        { n: "ROC-65", name: "Admiral Piett" },
        { n: "ROC-66", name: "Nien Nunb" },
        { n: "ROC-67", name: "R2-D2" },
        { n: "ROC-68", name: "Luke Skywalker" },
        { n: "ROC-69", name: "Chewbacca" },
        { n: "ROC-70", name: "Darth Vader" },
        { n: "ROC-71", name: "Han Solo" },
        { n: "ROC-72", name: "Luke Skywalker" },
        { n: "ROC-73", name: "The Emperor" },
        { n: "ROC-74", name: "The Emperor" },
        { n: "ROC-75", name: "Wedge Antilles" },
        { n: "ROC-76", name: "Nien Nunb" },
        { n: "ROC-77", name: "Admiral Ackbar" },
        { n: "ROC-78", name: "Admiral Piett" },
        { n: "ROC-79", name: "Luke Skywalker" },
        { n: "ROC-80", name: "Darth Vader" },
        { n: "ROC-81", name: "Wedge Antilles" },
        { n: "ROC-82", name: "Lando Calrissian" },
        { n: "ROC-83", name: "Nien Nunb" },
        { n: "ROC-84", name: "Luke Skywalker" },
        { n: "ROC-85", name: "Han Solo" },
        { n: "ROC-86", name: "Leia Organa" },
        { n: "ROC-87", name: "Luke Skywalker" },
        { n: "ROC-88", name: "Wicket W. Warrick" },
        { n: "ROC-89", name: "Lando Calrissian" },
        { n: "ROC-90", name: "Leia Organa" },
        { n: "ROC-91", name: "Han Solo" },
    ],
  },
  {
    id: "skeleton-crew-relic",
    type: "insert",
    title: "SKELETON CREW RELIC",
    parallels: [
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SCR-1", name: "KB Starport Dinghy: Skeleton Crew" },
        { n: "SCR-2", name: "Fern Starport Dinghy: Skeleton Crew" },
        { n: "SCR-3", name: "Wim Starport Dinghy: Skeleton Crew" },
        { n: "SCR-4", name: "Neel Starport Dinghy: Skeleton Crew" },
        { n: "SCR-5", name: "Dinghy Driver Starport Dinghy: Skeleton Crew" },
        { n: "SCR-6", name: "SM-33 Starport Dinghy: Skeleton Crew" },
        { n: "SCR-7", name: "Vane Starport Dinghy: Skeleton Crew" },
        { n: "SCR-8", name: "Gunter Starport Dinghy: Skeleton Crew" },
        { n: "SCR-9", name: "Brutus Starport Dinghy: Skeleton Crew" },
        { n: "SCR-10", name: "Jod Na Nawood Starport Dinghy: Skeleton Crew" },
    ],
  },
  {
    id: "short-circuit",
    type: "insert",
    title: "SHORT CIRCUIT",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "SHOC-1", name: "R2-D2" },
        { n: "SHOC-2", name: "BD-72" },
        { n: "SHOC-3", name: "MD-15C" },
        { n: "SHOC-4", name: "SE8 Waiter Droid" },
        { n: "SHOC-5", name: "D-0" },
        { n: "SHOC-6", name: "R4-DT" },
        { n: "SHOC-7", name: "First Order Interrogator Droid" },
        { n: "SHOC-8", name: "R5-X3" },
        { n: "SHOC-9", name: "Star Navigator Droid" },
        { n: "SHOC-10", name: "BB-8" },
        { n: "SHOC-11", name: "HK-87 Assassin Droid" },
        { n: "SHOC-12", name: "C2-B5" },
        { n: "SHOC-13", name: "R2-BHD" },
        { n: "SHOC-14", name: "1-JAC" },
        { n: "SHOC-15", name: "Chopper" },
        { n: "SHOC-16", name: "Lola" },
        { n: "SHOC-17", name: "Imperial Probe Droid" },
        { n: "SHOC-18", name: "Pip" },
        { n: "SHOC-19", name: "Scorpenek Annihilator Droid" },
        { n: "SHOC-20", name: "Homing Spider Droid" },
        { n: "SHOC-21", name: "G2-1B7" },
        { n: "SHOC-22", name: "K-2SO" },
        { n: "SHOC-23", name: "RA-7 Protocol Droid" },
        { n: "SHOC-24", name: "Nevarro Copper Droid" },
        { n: "SHOC-25", name: "C-3PO" },
        { n: "SHOC-26", name: "AD-4M" },
    ],
  },
  {
    id: "under-disguise",
    type: "insert",
    title: "UNDER DISGUISE",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "gold-metal", name: "Gold Metal", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "UN-1", name: "The Mandalorian" },
        { n: "UN-2", name: "Bo-Katan Kryze" },
        { n: "UN-3", name: "Captain Silvo" },
        { n: "UN-4", name: "Zorii Bliss" },
        { n: "UN-5", name: "The Armorer" },
        { n: "UN-6", name: "Jango Fett" },
        { n: "UN-7", name: "Kylo Ren" },
        { n: "UN-8", name: "Carib Diss" },
        { n: "UN-9", name: "Paz Vizsla" },
        { n: "UN-10", name: "Sith Trooper" },
        { n: "UN-11", name: "Alazmec" },
        { n: "UN-12", name: "Vicrul" },
        { n: "UN-13", name: "Kuruk" },
        { n: "UN-14", name: "Ushar" },
        { n: "UN-15", name: "Trudgen" },
        { n: "UN-16", name: "Ap'Lek" },
        { n: "UN-17", name: "Cardo" },
        { n: "UN-18", name: "Lando Calrissian" },
        { n: "UN-19", name: "Captain Enoch" },
        { n: "UN-20", name: "Night Trooper" },
        { n: "UN-21", name: "The Stranger" },
        { n: "UN-22", name: "Constable Zuvio" },
        { n: "UN-23", name: "Captain Rex" },
        { n: "UN-24", name: "Fennec Shand" },
        { n: "UN-25", name: "Boba Fett" },
        { n: "UN-26", name: "Darth Vader" },
    ],
  },
  {
    id: "2025-masterworks-on-card-autographs",
    type: "auto",
    title: "2025 MASTERWORKS ON CARD AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-framed", name: "Silver-Framed", print_run: 5, color: "#9aa7c0" },
        { id: "gold-framed", name: "Gold-Framed", print_run: 1, color: "#9aa7c0" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "A-33", name: "Nick Frost SM-33" },
        { n: "A-A", name: "Alison Brie Am" },
        { n: "A-AA", name: "Adria Arjona Bix Caleen" },
        { n: "A-AB", name: "Ahmed Best Jar Jar Binks" },
        { n: "A-AE", name: "Alden Ehrenreich Han Solo" },
        { n: "A-AK", name: "David Oyelowo Alexsandr Kallus" },
        { n: "A-AT", name: "Alan Tudyk K-2SO" },
        { n: "A-BDT", name: "Benicio del Toro DJ" },
        { n: "A-BDW", name: "Billy Dee Williams Lando Calrissian" },
        { n: "A-BL", name: "Billie Lourd Kaydel Connix" },
        { n: "A-BN", name: "Brian Blessed Boss Nass" },
        { n: "A-C", name: "Joonas Suotamo Kelnacca" },
        { n: "A-CA", name: "Diego Luna Cassian Andor" },
        { n: "A-CAM", name: "Carrie-Anne Moss Jedi Master Indara" },
        { n: "A-CB", name: "Charlie Barnett Yord Fandar" },
        { n: "A-CJ", name: "Carey Jones Krrsantan" },
        { n: "A-CL", name: "Christopher Lloyd Commissioner Helgait" },
        { n: "A-DB", name: "David Barclay Jabba The Hutt" },
        { n: "A-DC", name: "Dave Chapman BB-8" },
        { n: "A-DCC", name: "Dean-Charles Chapman Torbin" },
        { n: "A-DF", name: "Donald Faison Hype Fazon" },
        { n: "A-DG", name: "Domhnall Gleeson General Hux" },
        { n: "A-DK", name: "Dafne Keen Jecki Lon" },
        { n: "A-DL", name: "Denis Lawson Wedge Antilles" },
        { n: "A-DM", name: "Denise Gough Dedra Meero" },
        { n: "A-DO", name: "Dorian Kingi Cad Bane" },
        { n: "A-DR", name: "Daisy Ridley Rey" },
        { n: "A-EC", name: "Emilia Clarke Qi'ra" },
        { n: "A-EE", name: "Eman Esfandi Ezra Bridger" },
        { n: "A-EK", name: "Erin Kellyman Enfys Nest" },
        { n: "A-ES", name: "Emily Swallow The Armorer" },
        { n: "A-EW", name: "Elijah Wood Jace Rucklin" },
        { n: "A-F", name: "John Boyega Finn" },
        { n: "A-FB", name: "Sung Kang Fifth Brother" },
        { n: "A-FJ", name: "Felicity Jones Jyn Erso" },
        { n: "A-FPJ", name: "Freddie Prinze Jr. Kanan Jarrus" },
        { n: "A-FW", name: "Forest Whitaker Saw Gerrera" },
        { n: "A-GC", name: "Gwendoline Christie Captain Phasma" },
        { n: "A-GE", name: "Giancarlo Esposito Moff Gideon" },
        { n: "A-GN", name: "Ron Perlman Gha Nachkt" },
        { n: "A-GO", name: "Genevieve O'Reilly Mon Mothma" },
        { n: "A-GT", name: "George Takei Lok Durd" },
        { n: "A-HAY", name: "Hayden Christensen Darth Vader" },
        { n: "A-HC", name: "Hayden Christensen Anakin Skywalker" },
        { n: "A-HO", name: "Jim Cummings Hondo Ohnaka" },
        { n: "A-IM", name: "Ian McDiarmid Emperor Palpatine" },
        { n: "A-IS", name: "Ivanna Sakhno Shin Hati" },
        { n: "A-JAL", name: "Jaleel White Gunter" },
        { n: "A-JGL", name: "Joseph Gordon-Levitt Slowen Lo" },
        { n: "A-JI", name: "Jason Isaacs The Grand Inquisitor" },
        { n: "A-JL", name: "Jake Lloyd Anakin Skywalker" },
        { n: "A-JNN", name: "Jude Law Jod Na Nawood" },
        { n: "A-JT", name: "Justin Theroux Master Codebreaker" },
        { n: "A-KB", name: "Kyriana Kratter KB" },
        { n: "A-KK", name: "Keira Knightley Sabé" },
        { n: "A-KL", name: "Andy Serkis Kino Loy" },
        { n: "A-KMT", name: "Kelly Marie Tran Rose Tico" },
        { n: "A-KR", name: "Keri Russell Zorii Bliss" },
        { n: "A-KS", name: "Katee Sackhoff Bo-Katan Kryze" },
        { n: "A-L", name: "Lizzo The Duchess" },
        { n: "A-LD", name: "Laura Dern Vice Admiral Holdo" },
        { n: "A-LJJ", name: "Lee Jung-jae Jedi Master Sol" },
        { n: "A-LL", name: "Lucy Liu Bandit Leader" },
        { n: "A-LM", name: "Lars Mikkelsen Grand Admiral Thrawn" },
        { n: "A-LY", name: "Ashley Eckstein Ahsoka Tano" },
        { n: "A-MC", name: "Marton Csokas Poggle the Lesser" },
        { n: "A-MEW", name: "Mary Elizabeth Winstead Hera Syndulla" },
        { n: "A-MH", name: "Mark Hamill Luke Skywalker" },
        { n: "A-MJ", name: "Manny Jacinto The Stranger" },
        { n: "A-MNW", name: "Ming-Na Wen Fennec Shand" },
        { n: "A-MV", name: "Mercedes Varnado Koska Reeves" },
        { n: "A-MW", name: "Matthew Wood General Grievous" },
        { n: "A-NA", name: "Naomi Ackie Jannah" },
        { n: "A-NK", name: "Nick Kellington Klaud" },
        { n: "A-NLB", name: "Natasha Liu Bordizzo Sabine Wren" },
        { n: "A-OJJ", name: "O'Shea Jackson Jr. Kawlan Roken" },
        { n: "A-PB", name: "Paul Bettany Dryden Vos" },
        { n: "A-RA", name: "Riz Ahmed Bodhi Rook" },
        { n: "A-RD", name: "Rosario Dawson Ahsoka Tano" },
        { n: "A-RF", name: "Rupert Friend The Grand Inquisitor" },
        { n: "A-RH", name: "Rebecca Henderson Vernestra \"Vern\" Rwoh" },
        { n: "A-RP", name: "Ray Park Darth Maul" },
        { n: "A-S", name: "Andy Serkis Supreme Leader Snoke" },
        { n: "A-SC", name: "Silas Carson Ki-Adi-Mundi" },
        { n: "A-SH", name: "Shirley Henderson Babu Frik" },
        { n: "A-SL", name: "Simu Liu Lah Zhima" },
        { n: "A-SLJ", name: "Samuel L. Jackson Mace Windu" },
        { n: "A-SP", name: "Simon Pegg Unkar Plutt" },
        { n: "A-SS", name: "Stellan Skarsgård Luthen Rael" },
        { n: "A-SW", name: "Sam Witwer Maul" },
        { n: "A-TM", name: "Temuera Morrison Boba Fett" },
        { n: "A-TR", name: "Tim Rose Admiral Ackbar" },
        { n: "A-TW", name: "Taika Waititi IG-11" },
        { n: "A-W", name: "Andy Secombe Watto" },
        { n: "A-WD", name: "Warwick Davis Wicket W. Warrick" },
        { n: "A-ZB", name: "Zach Braff Freck" },
    ],
  },
  {
    id: "pen-autograph-relic",
    type: "auto",
    title: "PEN AUTOGRAPH RELIC",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "A-33", name: "Nick Frost SM-33" },
        { n: "A-AA", name: "Adria Arjona Bix Caleen" },
        { n: "A-AB", name: "Ahmed Best Jar Jar Binks" },
        { n: "A-AE", name: "Alden Ehrenreich Han Solo" },
        { n: "A-AK", name: "David Oyelowo Alexsandr Kallus" },
        { n: "A-BDT", name: "Benicio del Toro DJ" },
        { n: "A-BDW", name: "Billy Dee Williams Lando Calrissian" },
        { n: "A-BL", name: "Billie Lourd Kaydel Connix" },
        { n: "A-BN", name: "Brian Blessed Boss Nass" },
        { n: "A-C", name: "Joonas Suotamo Kelnacca" },
        { n: "A-CA", name: "Diego Luna Cassian Andor" },
        { n: "A-CAM", name: "Carrie-Anne Moss Jedi Master Indara" },
        { n: "A-CHB", name: "Charlie Barnett Yord Fandar" },
        { n: "A-CJ", name: "Carey Jones Krrsantan" },
        { n: "A-CL", name: "Christopher Lloyd Commissioner Helgait" },
        { n: "A-DB", name: "David Barclay Jabba The Hutt" },
        { n: "A-DC", name: "Dave Chapman BB-8" },
        { n: "A-DCC", name: "Dean-Charles Chapman Jedi Master Torbin" },
        { n: "A-DG", name: "Domhnall Gleeson General Hux" },
        { n: "A-DK", name: "Dafne Keen Jecki Lon" },
        { n: "A-DL", name: "Denis Lawson Wedge Antilles" },
        { n: "A-DM", name: "Denise Gough Dedra Meero" },
        { n: "A-DO", name: "Dorian Kingi Cad Bane" },
        { n: "A-DR", name: "Daisy Ridley Rey" },
        { n: "A-EC", name: "Emilia Clarke Qi'ra" },
        { n: "A-EE", name: "Eman Esfandi Ezra Bridger" },
        { n: "A-EK", name: "Erin Kellyman Enfys Nest" },
        { n: "A-ES", name: "Emily Swallow The Armorer" },
        { n: "A-EW", name: "Elijah Wood Jace Rucklin" },
        { n: "A-F", name: "John Boyega Finn" },
        { n: "A-FJ", name: "Felicity Jones Jyn Erso" },
        { n: "A-FPJ", name: "Freddie Prinze Jr. Kanan Jarrus" },
        { n: "A-FW", name: "Forest Whitaker Saw Gerrera" },
        { n: "A-GC", name: "Gwendoline Christie Captain Phasma" },
        { n: "A-GE", name: "Giancarlo Esposito Moff Gideon" },
        { n: "A-GN", name: "Ron Perlman Gha Nachkt" },
        { n: "A-GO", name: "Genevieve O'Reilly Mon Mothma" },
        { n: "A-GT", name: "George Takei Lok Durd" },
        { n: "A-HC", name: "Hayden Christensen Anakin Skywalker" },
        { n: "A-HO", name: "Jim Cummings Hondo Ohnaka" },
        { n: "A-IM", name: "Ian McDiarmid Emperor Palpatine" },
        { n: "A-IS", name: "Ivanna Sakhno Shin Hati" },
        { n: "A-JAL", name: "Jaleel White Gunter" },
        { n: "A-JI", name: "Jason Isaacs The Grand Inquisitor" },
        { n: "A-JNN", name: "Jude Law Jod Na Nawood" },
        { n: "A-JT", name: "Justin Theroux Master Codebreaker" },
        { n: "A-KB", name: "Kyriana Kratter KB" },
        { n: "A-KK", name: "Keira Knightley Sabé" },
        { n: "A-KL", name: "Andy Serkis Kino Loy" },
        { n: "A-KMT", name: "Kelly Marie Tran Rose Tico" },
        { n: "A-KR", name: "Keri Russell Zorii Bliss" },
        { n: "A-KS", name: "Katee Sackhoff Bo-Katan Kryze" },
        { n: "A-L", name: "Lizzo The Duchess" },
        { n: "A-LD", name: "Laura Dern Vice Admiral Holdo" },
        { n: "A-LJJ", name: "Lee Jung-jae Jedi Master Sol" },
        { n: "A-LM", name: "Lars Mikkelsen Grand Admiral Thrawn" },
        { n: "A-LY", name: "Ashley Eckstein Ahsoka Tano" },
        { n: "A-MC", name: "Marton Csokas Poggle the Lesser" },
        { n: "A-MEW", name: "Mary Elizabeth Winstead Hera Syndulla" },
        { n: "A-MH", name: "Mark Hamill Luke Skywalker" },
        { n: "A-MJ", name: "Manny Jacinto The Stranger" },
        { n: "A-MNW", name: "Ming-Na Wen Fennec Shand" },
        { n: "A-MW", name: "Matthew Wood General Grievous" },
        { n: "A-NA", name: "Naomi Ackie Jannah" },
        { n: "A-NK", name: "Nick Kellington Klaud" },
        { n: "A-NLB", name: "Natasha Liu Bordizzo Sabine Wren" },
        { n: "A-OJJ", name: "O'Shea Jackson Jr. Kawlan Roken" },
        { n: "A-PB", name: "Paul Bettany Dryden Vos" },
        { n: "A-RA", name: "Riz Ahmed Bodhi Rook" },
        { n: "A-RCC", name: "Ravi Cabot-Conyers Wim" },
        { n: "A-RD", name: "Rosario Dawson Ahsoka Tano" },
        { n: "A-RF", name: "Rupert Friend The Grand Inquisitor" },
        { n: "A-RH", name: "Rebecca Henderson Vernestra \"Vern\" Rwoh" },
        { n: "A-RP", name: "Ray Park Darth Maul" },
        { n: "A-S", name: "Andy Serkis Supreme Leader Snoke" },
        { n: "A-SLJ", name: "Samuel L. Jackson Mace Windu" },
        { n: "A-SS", name: "Stellan Skarsgård Luthen Rael" },
        { n: "A-SW", name: "Sam Witwer Maul" },
        { n: "A-TM", name: "Temuera Morrison Boba Fett" },
        { n: "A-TR", name: "Tim Rose Admiral Ackbar" },
        { n: "A-TW", name: "Taika Waititi IG-11" },
        { n: "A-VLB", name: "Vivien Lyra Blair Leia Organa" },
        { n: "A-W", name: "Andy Secombe Watto" },
        { n: "A-WD", name: "Warwick Davis Wicket W. Warrick" },
        { n: "A-ZB", name: "Zach Braff Freck" },
    ],
  },
  {
    id: "autograph-relic-cards",
    type: "auto",
    title: "AUTOGRAPH RELIC CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "ARC-DAW", name: "Rosario Dawson Ahsoka Tano TIE Fighter: Ahsoka" },
        { n: "ARC-EE", name: "Eman Esfandi Ezra Bridger TIE Fighter: Ahsoka" },
        { n: "ARC-ESP", name: "Giancarlo Esposito Moff Gideon Outland TIE Fighter: The Mandalorian" },
        { n: "ARC-GOU", name: "Denise Gough Dedra Meero Vaporator: Andor" },
        { n: "ARC-LEE", name: "Diana Lee Inosanto Morgan Elsbeth TIE Fighter: Ahsoka" },
        { n: "ARC-LIU", name: "Natasha Liu Bordizzo Sabine Wren TIE Fighter: Ahsoka" },
        { n: "ARC-LUNA", name: "Diego Luna Cassian Andor Missle: Andor" },
        { n: "ARC-PAS", name: "Pedro Pascal The Mandalorian Outland TIE Fighter: The Mandalorian" },
        { n: "ARC-SHI", name: "Leilani Shiu Jawa Outland TIE Fighter: The Mandalorian" },
        { n: "ARC-TEN", name: "David Tennant Huyang TIE Fighter: Ahsoka" },
        { n: "ARC-WES", name: "Wes Chatham Captain Enoch TIE Fighter: Ahsoka" },
    ],
  },
  {
    id: "duo-autographs",
    type: "auto",
    title: "DUO AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-framed", name: "Silver-Framed", print_run: 5, color: "#9aa7c0" },
        { id: "gold-framed", name: "Gold-Framed", print_run: 1, color: "#9aa7c0" },
      ],
    cards: [
        { n: "DUO-AA", name: "Andy Secombe Watto / Ahmed Best Jar Jar Binks" },
        { n: "DUO-DA", name: "Adria Arjona Bix Caleen / Denise Gough Dedra Meero" },
        { n: "DUO-DG", name: "Diego Luna Cassian Andor / Genevieve O'Reilly Mon Mothma" },
        { n: "DUO-HS", name: "Samuel L. Jackson Mace Windu / Natalie Portman Padmé Amidala" },
        { n: "DUO-IF", name: "Forest Whitaker Saw Gerrera / Ian Whyte Moroff" },
        { n: "DUO-JB", name: "Justin Theroux Master Codebreaker / Benicio del Toro DJ" },
        { n: "DUO-JBBW", name: "Billy Dee Williams Lando Calrissian / Jeremy Bulloch Boba Fett" },
        { n: "DUO-KA", name: "Kyle Soller Syril Karn / Adria Arjona Bix Caleen" },
        { n: "DUO-MD", name: "Manny Jacinto The Stranger / Dafne Keen Jecki Lon" },
        { n: "DUO-RH", name: "Hayden Christensen Anakin Skywalker / Rosario Dawson Ahsoka Tano" },
    ],
  },
  {
    id: "quad-autographs",
    type: "auto",
    title: "QUAD AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "Q-CALM", name: "Carrie-Anne Moss Jedi Master Indara / Dafne Keen Jedi Padawan Jecki Lon / Manny Jacinto The Stranger / Lee Jung-jae Master Sol" },
        { n: "Q-CLOUD", name: "Jeremy Bulloch Boba Fett / David Prowse Darth Vader / Harrison Ford Han Solo / Billy Dee Williams Lando Calrissian" },
        { n: "Q-DAKD", name: "Denise Gough Dedra Meero / Kyle Soller Syril Karn / Diego Luna Cassian Andor / Adria Arjona Bix Caleen" },
        { n: "Q-E3", name: "Hayden Christensen Darth Vader / Ian McDiarmid Darth Sidious / Ewan McGregor Obi-Wan Kenobi / Samuel L. Jackson Mace Windu" },
        { n: "Q-JNFJ", name: "Fred Tatasciore Captain Brutus / Jaleel White Gunter / Jude Law Jod Na Nawood / Nick Frost SM-33" },
    ],
  },
  {
    id: "rotj-film-cel-autograph-relic",
    type: "auto",
    title: "ROTJ FILM CEL AUTOGRAPH RELIC",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "RAR-AA", name: "Tim Rose Tim Rose" },
        { n: "RAR-AD", name: "Anthony Daniels Anthony Daniels" },
        { n: "RAR-BIL", name: "Billy Dee Williams Billy Dee Williams" },
        { n: "RAR-BW", name: "Billy Dee Williams Billy Dee Williams" },
        { n: "RAR-C3", name: "Anthony Daniels Anthony Daniels" },
        { n: "RAR-CAL", name: "Billy Dee Williams Billy Dee Williams" },
        { n: "RAR-CAR", name: "Carrie Fisher Carrie Fisher" },
        { n: "RAR-EM", name: "Ian McDiarmid Ian McDiarmid" },
        { n: "RAR-HA", name: "Mark Hamill Mark Hamill" },
        { n: "RAR-HF", name: "Harrison Ford Harrison Ford" },
        { n: "RAR-IAN", name: "Ian McDiarmid Ian McDiarmid" },
        { n: "RAR-IM", name: "Ian McDiarmid Ian McDiarmid" },
        { n: "RAR-IMD", name: "Ian McDiarmid Ian McDiarmid" },
        { n: "RAR-JB", name: "Jeremy Bulloch Jeremy Bulloch" },
        { n: "RAR-LA", name: "Billy Dee Williams Billy Dee Williams" },
        { n: "RAR-LU", name: "Mark Hamill Mark Hamill" },
        { n: "RAR-MC", name: "Ian McDiarmid Ian McDiarmid" },
        { n: "RAR-MH", name: "Mark Hamill Mark Hamill" },
        { n: "RAR-MP", name: "Michael Pennington Michael Pennington" },
        { n: "RAR-MQ", name: "Mike Quinn Mike Quinn" },
        { n: "RAR-PAL", name: "Ian McDiarmid Ian McDiarmid" },
        { n: "RAR-PIE", name: "Kenneth Colley Kenneth Colley" },
        { n: "RAR-PO", name: "Anthony Daniels Anthony Daniels" },
        { n: "RAR-ROS", name: "Tim Rose Tim Rose" },
        { n: "RAR-SO", name: "Harrison Ford Harrison Ford" },
        { n: "RAR-SW", name: "Simon Williamson Simon Williamson" },
        { n: "RAR-TR", name: "Tim Rose Tim Rose" },
        { n: "RAR-WAR", name: "Warwick Davis Warwick Davis" },
        { n: "RAR-WI", name: "Warwick Davis Warwick Davis" },
        { n: "RAR-WIC", name: "Warwick Davis Warwick Davis" },
        { n: "RAR-WW", name: "Warwick Davis Warwick Davis" },
        { n: "RAR-WWW", name: "Warwick Davis Warwick Davis" },
    ],
  },
  {
    id: "skeleton-crew-autograph-relic",
    type: "auto",
    title: "SKELETON CREW AUTOGRAPH RELIC",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SCAR-FRO", name: "Nick Frost SM-33 Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-JAL", name: "Jaleel White Gunter Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-KK", name: "Kyriana Kratter KB Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-LAWA", name: "Jude Law Jod Na Nawood Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-MAT", name: "Marti Matulis Vane Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-RCC", name: "Ravi Cabot-Conyers Wim Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-STS", name: "Robert Timothy Smith Neel Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-TAT", name: "Fred Tatasciore Brutus Starport Dinghy: Skeleton Crew" },
        { n: "SCAR-WIT", name: "Sam Witwer Dinghy Driver Starport Dinghy: Skeleton Crew" },
    ],
  },
  {
    id: "trio-autographs",
    type: "auto",
    title: "TRIO AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "wood", name: "Wood", print_run: null, color: "#c8946a" },
        { id: "silver-framed", name: "Silver-Framed", print_run: null, color: "#9aa7c0" },
        { id: "gold-framed", name: "Gold-Framed", print_run: null, color: "#9aa7c0" },
      ],
    cards: [
        { n: "T-AHE", name: "Ewan McGregor Obi-Wan Kenobi / Hayden Christensen Anakin Skywalker / Anthony Daniels C-3PO" },
        { n: "T-DJA", name: "Daisy Ridley Rey / Anthony Daniels C-3PO / Joonas Suotamo Chewbacca" },
        { n: "T-FAV", name: "Vanessa Marshall Hera Syndulla / Freddie Prinze Jr. Kanan Jarrus / Ashley Eckstein Ahsoka Tano" },
        { n: "T-NJR", name: "Jude Law Jod Na Nawood / Robert Timothy Smith Neel / Nick Frost SM-33" },
        { n: "T-STP", name: "Sophie Thatcher Drash / Pedro Pascal The Mandalorian / Temuera Morrison Boba Fett" },
    ],
  },
  {
    id: "ultimate-book-card-autographs",
    type: "auto",
    title: "ULTIMATE BOOK CARD AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "UBC-456", name: "Jeremy Bulloch Boba Fett / Billy Dee Williams Lando Calrissian / Ian McDiarmid The Emperor / David Prowse Darth Vader / Anthony Daniels C-3PO / Peter Mayhew Chewbacca / Carrie Fisher Leia Organa / Harrison Ford Han Solo / Mark Hamill Luke Skywalker / David Barclay Jabba the Hutt" },
        { n: "UBC-MAN", name: "Mark Hamill Luke Skywalker / Katee Sackhoff Bo-Katan Kryze / Taika Waititi IG-11 / Christopher Lloyd Commissioner Helgait / Rosario Dawson Ahsoka Tano / Pedro Pascal The Mandalorian / Temuera Morrison Boba Fett / Giancarlo Esposito Moff Gideon / Ming-Na Wen Fennec Shand / Timothy Olyphant Cobb Vanth" },
        { n: "UBC-REV", name: "Temuera Morrison Clone Commander Cody / Anthony Daniels C-3PO / Peter Mayhew Chewbacca / Ian McDiarmid Darth Sidious / Amy Allen Aayla Secura / Ewan McGregor Obi-Wan Kenobi / Natalie Portman Padmé Amidala / Hayden Christensen Anakin Skywalker / Samuel L. Jackson Mace Windu / Matthew Wood General Grievous" },
        { n: "UBC-SKY", name: "Anthony Daniels C-3PO / Dominic Monaghan Beaumont Kin / Billy Dee Williams Lando Calrissian / John Boyega Finn / Mike Quinn Nien Nunb / Billie Lourd Kaydel Ko Connix / Oscar Isaac Poe Dameron / Dave Chapman BB-8 / Daisy Ridley Rey / Adam Driver Kylo Ren" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
